<template>
  <div
    @mouseenter="homeLearnHover({ label: title, url: linkToTrack })"
    @click="homeLearnClick({ label: title, url: linkToTrack })"
  >
    <a
      class="home-learn-card"
      target="_blank"
      rel="noopener noreferrer"
      :href="link.href"
    >
      <div class="image-container">
        <DpplSvg :file-name="imgSrc" />
      </div>
      <div class="content-container pa-4">
        <span class="learn-card-title mb-2 text-left">{{ title }}</span>
        <span class="learn-card-description text-left mb-2">{{ description }}</span>
        <span class="d-flex align-center justify-center mt-auto call-to-action">
          <DpplSvg
            :file-name="link.svg"
            class="mr-1"
          />
          <span class="learn-link-text">{{ link.text }}</span>
        </span>
      </div>
    </a>
  </div>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { mapActions } from 'pinia';
import { useAppPlatform } from '@/stores/app/platform';

export default {
  name: 'HomeLearnCard',
  components: {
    DpplSvg,
  },
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    link: { type: Object, required: true },
    imgSrc: { type: String, default: '' },
  },
  computed: {
    linkToTrack() {
      if (this.imgSrc === 'articles/datapeople-university-card') return 'https://university.datapeople.io/certifications';
      return this.link.href;
    },
  },
  methods: {
    ...mapActions(useTracking, ['homeLearnHover', 'homeLearnClick']),
    ...mapActions(useAppPlatform, ['getAutoLoginHelpLinks']),
  },
};
</script>

<style lang="less" scoped>
.home-learn-card {
  width: 220px;
  height: 262px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  .content-container .call-to-action {
    transition: all 300ms ease;
  }

  &:hover .content-container .call-to-action {
    transform: translateX(4px);
  }
}

.image-container {
  width: 100%;
  height: 88px;
  background: fade(@grey-400, 20%);
}

.content-container {
  background: fade(@basic-blue, 10%);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  .learn-card-title {
    font-size: 14px;
    font-weight: 500;
    color: @text-darkest;
  }

  .learn-card-description {
    font-size: 14px;
    font-weight: 300;
    color: @text-darkest;
  }

  :deep(svg) path {
    fill: @basic-blue;
  }

  .learn-link-text {
    font-size: 12px;
    font-weight: 500;
    color: @basic-blue;
  }
}
</style>
